import { IColumnConfig, ICustomScreenLayout, IRecentScreen, IScreen } from "bi-interfaces";

export class UserUIProfile{
    public IsCurrentScreenFavorite: boolean = false;
    public FavoriteScreens: IScreen[] = []
    public RecentScreens: IRecentScreen[] = [];
    public BS_CustomScreenLayout: ICustomScreenLayout | null = null;
    public BS_GridColumnConfigs: IColumnConfig[] = [];
    constructor(){}
}